import React, { useState, useEffect} from 'react';
import SideNavBar from './SideNavBar';
import { Outlet, useNavigate } from 'react-router-dom';

const Layout = () => {
    const [menuCollapse, setMenuCollapse] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 650) {
                setMenuCollapse(true);
            } else {
                setMenuCollapse(false);
            }
        };
  
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(()=>navigate("/dashboard"),[])
    
    return (
      <div style={{ display: "flex" }}>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: menuCollapse ? "90px" : "200px",
            transition: "width 1s ease",
            zIndex: 1000,
            overflow: "hidden",
          }}
        >
          <SideNavBar
            menuCollapse={menuCollapse}
            setMenuCollapse={setMenuCollapse}
          />
        </div>
        <div
          style={{
            marginLeft: menuCollapse ? "60px" : "200px",
            transition: "margin-left 1s ease",
            padding: "20px",
            height: "100vh",
            overflowY: "auto",
            width: "100%",
          }}
        >
          <Outlet />
        </div>
      </div>
    );
};

export default Layout;
